module.exports = __webpack_public_path__ + "img/404.792e9567.png";